export default __webpack_public_path__ + "static/media/im2.28950860.png";